export const selectPhotos = state => state.photos.search;
export const selectLatestPhotos = state => state.photos.latest;
export const selectMostPopularPhotos = state => state.photos.mostPopular;
export const selectRelatedPhotos = state => state.photos.related;
export const selectPhotosTags = state => state.photos.tags;
export const selectRejectedPhotos = state => state.photos.rejected;
export const selectProfileMeta = state => state.photos.profileMeta;
export const selectNextUrlPhotos = state => state.photos.search.next;
